import React from "react";
import { Row, Col, Card, Button } from "antd";
import "./index.css";
const AccountInfo = ({ companyDetails, isOpenSubcriptionModal }) => {
  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Row justify="start">
          <Col
            xs={24}
            sm={24}
            md={22}
            lg={24}
            xl={24}
            style={{ border: "0.5px solid #eaefef" }}
          >
            <Card>
              <Row justify="start" gutter={[0, 20]}>
                <Col span={24}>
                  <h3 className="text-left">Account Information</h3>
                </Col>
                <Col xs={10} sm={10} md={4} lg={6} xl={6}>
                  <Button className="account-btn">Active</Button>
                </Col>
                <Col xs={17} sm={17} md={20} lg={18} xl={18}>
                  <p className="account-description text-left">
                    You have subscribed for this service until{" "}
                    {companyDetails.subscription_period_end}.Card Used **** ****
                    **** 4242
                  </p>
                  <p
                    className="account-subscription pointer-cursor"
                    onClick={isOpenSubcriptionModal}
                  >
                    Manage subscription
                  </p>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AccountInfo;
